<template>
    <div id="container">
<div id="content" v-loading="loading" element-loading-text="Loading...">
            <template v-if="total > 0">
                <h1>Search Results ({{ pageSize * (currentPage-1) + 1 }}-{{ pageSize * (currentPage-1) + tasks.length }} of {{ total }})</h1>
                <el-pagination v-if="total > 200" layout="total, ->, prev, pager, next" :page-size="pageSize" :total="total" :current-page="currentPage" @current-change="handleChangePage"></el-pagination>
                <a @click="toggleShowDetails">{{ showDetails ? "hide details" : "show all details" }}</a>
                <tasks-tasks :tasks="tasks" :showDetails="showDetails" @sortdata="val => handleSort(val)"></tasks-tasks>
                <el-pagination v-if="total > 200" layout="total, ->, prev, pager, next" :page-size="pageSize" :total="total" :current-page="currentPage" @current-change="handleChangePage"></el-pagination>
            </template>
            <template v-else-if="total === 0">
                <h1>No record matched your search terms.</h1>
            </template>
        </div>
        </div>
</template>

<script>
    import axios from 'axios'



    export default {
        metaInfo () {
            return {
                title:"Search Results (" + (this.pageSize * (this.currentPage-1) + 1) + "-" + (this.pageSize * (this.currentPage-1) + this.tasks.length) + " of " + this.total + ")"
            }
        },

        components: {
        },
        data () {
            return {
                urlParams: {},
                pageSize: 200,
                currentPage: 1,
                total: null,
                prop: "last_updated_at",
                order: "descending",
                showDetails: false,
                tasks: [],
                searchField1: null,
                searchTerm1: null,
                searchField2: null,
                searchTerm2: null,
                searchField3: null,
                searchTerm3: null,
                loading: false
            }
        },
        methods: {
            handleChangePage: function(val) {
                this.currentPage = val;
                this.getTasks();
            },
            load: function() {
                this.urlParams = this.$route.query;

                this.searchField1 = this.urlParams.search_field_1;
                this.searchTerm1 = this.urlParams.search_term_1;
                this.searchField2 = this.urlParams.search_field_2;
                this.searchTerm2 = this.urlParams.search_term_2;
                this.searchField3 = this.urlParams.search_field_3;
                this.searchTerm3 = this.urlParams.search_term_3;

                this.getTasks();
            },
            toggleShowDetails: function(){
                this.showDetails = !this.showDetails;
                this.getTasks();
            },
            getTasks: function() {
                this.loading=true;
                axios.get('/api/task/search/', {params: {search_field_1: this.searchField1, search_term_1: this.searchTerm1, search_field_2: this.searchField2, search_term_2: this.searchTerm2, search_field_3: this.searchField3, search_term_3: this.searchTerm3, start: this.pageSize * (this.currentPage-1), limit: this.pageSize, prop: this.prop, order: this.order}})
                    .then(response => {
                        if(response.data.success) {
                            this.tasks = response.data.rows;
                            this.total = response.data.total;
                        }
                        this.loading=false;
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            },
            handleSort: function(sortObj){
                this.prop = sortObj.prop;
                this.order = sortObj.order;
                this.getTasks();
            }
        },
        created () {
            this.load();
        }
    }
</script>
<style scoped>
</style>
